import type { TaskNode } from "./types";
import type { VersionEdit } from "./versions";

// Apply parsed edits to the named estimate streams. A rename line ("old -> new") moves the
// value stored under key `old` to key `new` in every node's `estimates` map (summing if the
// target already exists); returns the new ordered name list. Mirrors applyVersionEdits, but
// operates on a per-node numeric MAP rather than a single label field.
export function applyEstimationEdits(tree: TaskNode[], edits: VersionEdit[]): string[] {
  const renames = new Map<string, string>();
  for (const e of edits) if (e.from && e.from !== e.name) renames.set(e.from, e.name);
  if (renames.size) {
    (function walk(list: TaskNode[]) {
      for (const n of list) {
        for (const [from, to] of renames) {
          if (Object.prototype.hasOwnProperty.call(n.estimates, from)) {
            n.estimates[to] = (n.estimates[to] || 0) + n.estimates[from];
            delete n.estimates[from];
          }
        }
        walk(n.children);
      }
    })(tree);
  }
  return edits.map((e) => e.name);
}
